// Legacy "Human in the Loop" queue URL — merged into the unified Inbox
// (`/inbox`) in the 2026-07 nav review: the Inbox's "Pending decisions"
// section is the same GET /v1/hitl/pending queue this page used to
// render, plus open signals and SSE live updates.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../../lib/constants';

export const Route = createFileRoute('/triage/hitl/')({
  beforeLoad: () => {
    throw redirect({ to: routes.INBOX, replace: true });
  },
  component: () => null,
});
